<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="Activity" subtitle="Browse user and system activity for volunteers." :readonly="$authorised('con/volunteers/access', 'read')" />

	<app-content-filters :changed="isFilterDirty" v-on:reset="onResetFilter">

		<app-content-filters-search v-model="filter.search" />
		
		<app-content-filters-tags v-model="filter.tags" :options="$util.options(filterTags)" />

		<app-content-filters-select v-model="filter.action" tooltip="Filter by action" text="Action" :options="$util.options(actionOptions)" />
		
		<app-content-filters-select v-model="filter.type" tooltip="Filter by type" text="Type" :options="$util.options(typeOptions)" />
		
		<app-content-filters-date v-model="filter.from" tooltip="Filter from date" text="From" :max="filter.to" />
		
		<app-content-filters-date v-model="filter.to" tooltip="Filter to date" text="To" :min="filter.from" />
		
	</app-content-filters>

	<app-content-body :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no activity found.">

		<app-table>

			<app-table-head :layout="layout">

				<app-table-column text="Action" />
				
				<app-table-column text="User" />
				
				<app-table-column text="Data" />
				
				<app-table-column text="Timestamp" />

			</app-table-head>

			<app-table-body>

				<app-table-row v-on:click="onEditClick(item)" :layout="layout" v-for="item in collection" :key="item.id" v-tooltip="'Click to see full audit'">

					<app-table-cell-activity :action="item" />
					
					<app-table-cell-item type="admin" :item="item.user" v-if="item.user && !item.badge" :showIcon="true" />
					<app-table-cell-item type="convention/badge" :item="item.badge" v-if="item.badge" :showIcon="true" />
					<app-table-cell-text text="System" v-if="!item.user && !item.badge" />
					
					<app-table-cell-item :type="item.type" :item="item.data" :no-extra="true" />
					
					<app-table-cell-text :text="item.date | localDate('MM/DD/YYYY h:mma')" />

				</app-table-row>

			</app-table-body>

			<app-table-foot :pagination="pagination" :total="total" />

		</app-table>

	</app-content-body>

	<com-activity v-if="is.auditing" :item="is.auditing" v-on:close="is.auditing = false" />

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

import comActivity from './common/panel/Activity'

export default {

	mixins: [mixCollection],
	
	components: {
		'com-activity': comActivity
	},

	data: function() {

		return {
			is: {
				auditing: false,
			},
			filter: {
				tags: [],
				from: false,
				to: false,
				type: false
			},
			filterTags: {
				'admin': 'Admins',
				'attendee': 'Attendees',
				'system': 'System'
			},
			actionOptions: {
				'created': 'Created',
				'updated': 'Updated',
				'deleted': 'Deleted',
				'accepted': 'Accepted',
				'rejected': 'Rejected',
				'cancelled': 'Cancelled',
				'restored': 'Restored',
				'retracted': 'Retracted',
				'generated': 'Generated'
			},
			typeOptions: {
				'convention/volunteers/role': 'Role',
				'convention/volunteers/slot': 'Slot',
				'convention/volunteers/assignment': 'Assignment',
				'convention/volunteers/whitelist': 'Pre-approval',
				'convention/volunteers/signup': 'Sign-up'
			},
			layout: '1fr 240px 240px 160px',
			endpoint: 'convention/volunteers/activity',
			live: 'convention/volunteers/activity'
		}

	},

	methods: {
	
		onEditClick: function(value) {

			if(!this.is.auditing) {
		
				this.is.auditing = value

			}
		
		}
	
	}

}

</script>

<style scoped>

</style>